import React from 'react';
import './LoadingSkeleton.css';

const LoadingSkeleton = ({ 
  type = 'card', 
  count = 1, 
  className = '' 
}) => {
  const renderSkeleton = () => {
    switch (type) {
      case 'story-card':
        return (
          <div className="skeleton-story-card">
            <div className="skeleton-image"></div>
            <div className="skeleton-content">
              <div className="skeleton-title"></div>
              <div className="skeleton-subtitle"></div>
              <div className="skeleton-meta">
                <div className="skeleton-tag"></div>
                <div className="skeleton-tag"></div>
              </div>
            </div>
          </div>
        );
      
      case 'story-page':
        return (
          <div className="skeleton-story-page">
            <div className="skeleton-page-header">
              <div className="skeleton-page-title"></div>
              <div className="skeleton-actions"></div>
            </div>
            <div className="skeleton-page-content">
              <div className="skeleton-page-image"></div>
              <div className="skeleton-page-text">
                <div className="skeleton-line"></div>
                <div className="skeleton-line"></div>
                <div className="skeleton-line short"></div>
              </div>
            </div>
          </div>
        );
      
      case 'profile':
        return (
          <div className="skeleton-profile">
            <div className="skeleton-avatar"></div>
            <div className="skeleton-profile-info">
              <div className="skeleton-name"></div>
              <div className="skeleton-email"></div>
            </div>
          </div>
        );
      
      case 'feature':
        return (
          <div className="skeleton-feature">
            <div className="skeleton-feature-icon"></div>
            <div className="skeleton-feature-title"></div>
            <div className="skeleton-feature-text">
              <div className="skeleton-line"></div>
              <div className="skeleton-line"></div>
            </div>
          </div>
        );
      
      default:
        return (
          <div className="skeleton-card">
            <div className="skeleton-header"></div>
            <div className="skeleton-body">
              <div className="skeleton-line"></div>
              <div className="skeleton-line"></div>
              <div className="skeleton-line short"></div>
            </div>
          </div>
        );
    }
  };

  return (
    <div className={`loading-skeleton ${className}`}>
      {Array.from({ length: count }, (_, index) => (
        <div key={index} className="skeleton-item">
          {renderSkeleton()}
        </div>
      ))}
    </div>
  );
};

export default LoadingSkeleton;
